// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Hb","heading":"Ib","brandPromo":"Jb"};